import React, { useEffect, useState } from 'react'
import { fetchCouponList } from '../api'
import Client from '../../models/client'
import { CouponListSearchForm, FormData } from './CouponListSearchForm'
import { Box, Group, ThemeIcon, Title } from '@mantine/core'
import { TicketIcon } from '@phosphor-icons/react'
import { CouponListData, CouponListTable, CouponRow } from './CouponListTable'

const EMPTY_DATA: CouponListData = { columns: [], rows: [] }

interface Props {
  client: Client
}

type ApiCouponColumn = { Header: string; accessor: string; width?: number }

const CouponList: React.FC<Props> = ({ client }) => {
  const [params, setParams] = useState({
    duplicate: false,
    is_test: false,
  })

  const [fetching, setFetching] = useState(true)
  const [data, setData] = useState<CouponListData>(EMPTY_DATA)

  useEffect(() => {
    setFetching(true)
    fetchCouponList(client.id, params.duplicate, params.is_test)
      .then((res: { columns: ApiCouponColumn[]; rows: CouponRow[] }) =>
        setData({
          columns: res.columns.map((c) => ({
            headerName: c.Header,
            field: c.accessor,
            width: c.width,
          })),
          rows: res.rows,
        }),
      )
      .catch(() => setData(EMPTY_DATA))
      .finally(() => setFetching(false))
  }, [client.id, params.duplicate, params.is_test])

  return (
    <Box>
      <Group gap={12} mb={16}>
        <ThemeIcon variant="transparent" color="#4BC1C7">
          <TicketIcon weight="fill" size={36} />
        </ThemeIcon>
        <Title size={24} fw={600} c="#000000CC">クーポン利用管理</Title>
      </Group>

      <CouponListSearchForm handleSearchForm={setParams} />
      <CouponListTable data={data} fetching={fetching} />
    </Box>
  )
}

export default CouponList
